import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { conversationId: Number }

  async trigger(event) {
    event.preventDefault()

    const button = event.currentTarget
    const originalContent = button.innerHTML

    // Show loading state
    button.disabled = true
    button.innerHTML = `
      <svg class="w-3.5 h-3.5 animate-spin" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      <span>Consultando...</span>
    `

    try {
      const response = await fetch(`/api/v1/conversations/${this.conversationIdValue}/trigger_credit_analysis`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
        }
      })

      const data = await response.json()

      if (response.ok) {
        window.location.reload()
      } else {
        alert(data.error || 'Erro ao consultar score')
        button.disabled = false
        button.innerHTML = originalContent
      }
    } catch (error) {
      console.error('Credit analysis error:', error)
      alert('Erro ao consultar score')
      button.disabled = false
      button.innerHTML = originalContent
    }
  }
}
